import {
  GOOGLE_ADS_CAMPAIGN_STATUS,
  GoogleAdsCampaignConnectionStatus,
} from '../../../../../../services/exports/Constants';

export default {
  title: 'Google Ads',
  search: {
    placeholder: 'Rechercher par ID, nom ou entreprise',
  },
  filters: {
    connection_statuses: {
      placeholder: 'Statut de connexion',
      options: {
        [GoogleAdsCampaignConnectionStatus.Connected]: 'Connecté',
        [GoogleAdsCampaignConnectionStatus.NotConnected]: 'Non connecté',
      },
    },
  },
  columns: {
    name: 'Nom',
    company: 'Entreprise',
    connected: 'Connecté',
    action: 'Action',
    details: 'Détails',
    address: 'Adresse',
    status: 'Statut',
  },
  status: {
    [GOOGLE_ADS_CAMPAIGN_STATUS.UNSPECIFIED]: 'Non spécifié',
    [GOOGLE_ADS_CAMPAIGN_STATUS.ENABLED]: 'Actif',
    [GOOGLE_ADS_CAMPAIGN_STATUS.PAUSED]: 'En pause',
    [GOOGLE_ADS_CAMPAIGN_STATUS.UNKNOWN]: 'Inconnu',
    [GOOGLE_ADS_CAMPAIGN_STATUS.REMOVED]: 'Supprimé',
  },
};
